import { render } from "./TV.vue?vue&type=template&id=e9e83aac"
import script from "./TV.vue?vue&type=script&lang=js"
export * from "./TV.vue?vue&type=script&lang=js"

import "./TV.vue?vue&type=style&index=0&id=e9e83aac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__